import { render, staticRenderFns } from "./DaftarVaksin.vue?vue&type=template&id=35d621ff&scoped=true"
import script from "./DaftarVaksin.vue?vue&type=script&lang=js"
export * from "./DaftarVaksin.vue?vue&type=script&lang=js"
import style0 from "./DaftarVaksin.vue?vue&type=style&index=0&id=35d621ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d621ff",
  null
  
)

export default component.exports